var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6097 4.49274C15.9863 3.14169 18.1974 3.16235 19.5484 4.53888C20.8995 5.91541 20.8788 8.12655 19.5023 9.4776L9.71914 19.0797C9.44276 19.3509 9.08499 19.524 8.70075 19.5722L8.60732 18.8281L8.70075 19.5722L5.59421 19.9623C4.57871 20.0898 3.72062 19.2155 3.86706 18.2025L4.31507 15.1038L5.05572 15.2109L4.31507 15.1038C4.37049 14.7206 4.55018 14.3661 4.82655 14.0948L14.6097 4.49274ZM18.4779 5.58958C17.7072 4.80429 16.4457 4.7925 15.6604 5.56326L5.87726 15.1653C5.83532 15.2065 5.80805 15.2603 5.79964 15.3185L5.05735 15.2111L5.79964 15.3185L5.35163 18.4172C5.35001 18.4284 5.35138 18.4351 5.35302 18.4399C5.35505 18.4458 5.35901 18.4528 5.36543 18.4594C5.37185 18.4659 5.37876 18.47 5.38468 18.4721C5.38946 18.4739 5.39614 18.4753 5.40734 18.4739L8.51389 18.0839C8.5722 18.0766 8.62649 18.0503 8.66843 18.0092L18.4516 8.40708C19.2369 7.63632 19.2487 6.37488 18.4779 5.58958Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5188 5.75086C14.8144 5.46072 15.2892 5.46515 15.5794 5.76077L18.7315 8.97234C19.0216 9.26795 19.0172 9.74281 18.7216 10.033C18.426 10.3231 17.9511 10.3187 17.661 10.023L14.5088 6.81148C14.2187 6.51586 14.2231 6.04101 14.5188 5.75086Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.38c42abb.svg";
export { ForwardRef as ReactComponent };